<template>
  <div v-if="false" class="header-bar">
    <van-icon @click="handleBack" class="back-icon" name="arrow-left" />
    <h1 class="popup-title ellipsis">{{ worWxTitle }}</h1>
    <div
      v-if="!showHeader"
      @click="handleIcon"
      data-flex="cross:center"
      class="header-right"
    >
      <van-icon name="wap-home" />
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import { isWx } from '@/utils/utils.js'
export default {
  name: 'HeaderBar',
  props: {
    customBack: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    iconBack: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isWxWork: isWx('work')
    }
  },
  computed: {
    worWxTitle() {
      return this.$props.title || this.$route.meta.title
    }
  },
  methods: {
    handleBack() {
      if (!this.customBack) {
        return this.$router.go(-1)
      }
      this.$emit('back')
    },
    handleIcon() {
      if (!this.iconBack) {
        return this.$router.push({
          path: `/agent/index`,
          query: {
            zbid: zbvd.zbid
          }
        })
      }
      this.$emit('back')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-bar {
  position: sticky;
  left: 0;
  top: 0;
  background: #fff;
  width: 100%;
  padding: 0 10px 0 8px;
  box-sizing: border-box;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  z-index: 99;
  .back-icon {
    font-size: 18px;
    color: #202124;
  }
  .popup-title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #161616;
    line-height: 20px;
  }
  .submit-text {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #006cff;
    line-height: 20px;
    &:not(:last-of-type) {
      margin-right: 12px;
    }
  }
  .header-right {
    .van-icon {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
